import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { KButtonType } from 'ng-k-button';
import { IKCard, KCardFieldType } from 'ng-k-card';
import { ClaimsService } from 'src/app/services/claims.service';
import { GlobalLoadingService } from 'src/app/services/global-loading.service';
import * as moment from 'moment';
import { KIconType } from 'ng-k-icon';

@Component({
  selector: 'app-radiological-progression-chart-carcinoma',
  templateUrl: './radiological-progression-chart-carcinoma.component.html',
  styleUrls: ['./radiological-progression-chart-carcinoma.component.scss']
})
export class RadiologicalProgressionChartCarcinomaComponent implements OnInit {

  public claimId: any;
  public chartTitle: any;
  public radProgId: any;
  KButtonType = KButtonType;
  public claimInfo: IKCard = {};
  public claimInfo2: IKCard = {};
  public claimData: any = [];
  public customData: any;

  constructor(
    private router:Router,
    private route: ActivatedRoute,
    private loaderService: GlobalLoadingService,
    private claimsService: ClaimsService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.claimId = decodeURIComponent(params['claimId']);
      this.chartTitle = decodeURIComponent(params['title']);
      this.radProgId = params['radProgressionId'] ? decodeURIComponent(params['radProgressionId']) : '';
    });
    this.getWorkflowOverview(this.claimId);
  }

  goToPage() {
    this.router.navigate(['/claimDetail/', this.claimId, 'medical']);
  }

  public getWorkflowOverview(claimID: any) {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = claimID ? claimID : null;
    this.loaderService.startLoadingIndicator('getWorkflowOverview');

    thisObj.claimsService.getWorkflowOverview(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getWorkflowOverview');
        this.claimData = result.data.meta;
        this.customData = {
          claimId : this.claimId,
          claimantName : this.claimData.claimant.claimantName,
          chartTitle: this.chartTitle,
          medicalConditionLabel: 'Carcinoma of the Lung',
          medicalConditionValue: 'carcinoma-of-the-lung'
        }
        this.getClaimInfo(this.claimId);
      }
    },
    err => {
      console.log(err.error);
      this.loaderService.stopLoadingIndicator('getWorkflowOverview');
      if (err.error.status === 'Unprocessable') {
        this.loaderService.stopLoadingIndicator('getWorkflowOverview');
        this.claimData = [];
      }
    });
  }

  public getClaimInfo(claimID: any) {
    this.loaderService.startLoadingIndicator('getClaimInfo');
    this.claimInfo = {
      value: '',
      header: {
        label: moment(new Date(this.claimData.claim.createdDate)).format('DD/MM/YYYY'),
        labelColour: 'brand-main',
        icon: {
          type: KIconType.fas,
          name: 'clock'
        }
      },
      clickable: false,
      fields: [
        {
          fieldType: KCardFieldType.IdRef,
          label: 'Claim Reference',
          value: this.claimData?.claimant?.claimReference ? this.claimData?.claimant?.claimReference : ' ',
          icon: {
            type: KIconType.fas,
            name: 'tag',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Text,
          label: 'Claimant Name',
          value: this.claimData.claimant.claimantName,
          icon: {
            type: KIconType.fas,
            name: 'user',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Text,
          label: 'Condition',
          value: this.claimData.claimant.condition,
          icon: {
            type: KIconType.fas,
            name: 'stethoscope',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Link,
          label: 'Open >',
          value: '/claimForm/' + encodeURIComponent(this.claimId),
        }
      ]
    }
    let amountSymbol = ''

    this.claimInfo2 = {
      value: '',
      clickable: false,
      fields: [
        {
          fieldType: KCardFieldType.IdRef,
          label: 'Claim Amount',
          value: this.claimData.claim.claimAmount != 0 ? this.claimData.claim.claimAmount : '0',
          icon: {
            type: KIconType.fas,
            name: 'wallet',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Text,
          label: 'No. of Defendants',
          value: this.claimData.claim.noOfDefendants ? this.claimData.claim.noOfDefendants : ' ',
          icon: {
            type: KIconType.kennedys,
            name: 'defendant',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Text,
          label: 'No. of Insurers',
          value: this.claimData.claim.insurersInfo.value + ' Insurer(s)',
          icon: {
            type: KIconType.kennedys,
            name: 'insurer',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Text,
          label: this.claimData.claim.employersInfo.type == 'name' ? 'Employer name' : 'No. of Employers',
          value: this.claimData.claim.employersInfo.type == 'name' ? (this.claimData.claim.employersInfo.value) : (this.claimData.claim.employersInfo.value + ' Employer(s)'),
          icon: {
            type: KIconType.fas,
            name: 'user-tie',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Link,
          label: 'Full Apportionment >',
          value: '/claimForm/' + encodeURIComponent(this.claimId),
        }
      ]
    }
    this.loaderService.stopLoadingIndicator('getClaimInfo');
  }

  public viewChartValues() {
    this.router.navigate([`carcinoma-of-the-lung/radiological-progression/edit-chart/`, this.claimId, this.radProgId]);
  }
}
